import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormGroup } from 'react-bootstrap';
import { Row, Col } from 'react-flexbox-grid';

import EventStatusFilterTypes from '../../event_status_filter_types';
import {
  GlgCustomDropdown,
  GlgTooltipIcon,
} from 'SharedComponents';
import CheckboxPanel from './event_status/checkbox_panel';
import DropdownButton from './event_status/dropdown_button';
import { useEffect } from 'react';

const EventStatusFilter = ({
  values,
  onChange,
  statusFilterVisible,
  showTours,
  shouldShowLotteryFilter,
  disabled
}) => {

  const OPTIONS = [
    {
      value: EventStatusFilterTypes.REGISTERED,
      label: window.I18n?.t('customer_directories.filters.event_status_options.my_registrations') || '',
      checked: values.includes(EventStatusFilterTypes.REGISTERED),
    },
    {
      value: EventStatusFilterTypes.OPEN,
      label: window.I18n?.t('customer_directories.filters.event_status_options.registration_open') || '',
      checked: values.includes(EventStatusFilterTypes.OPEN),
    },
    {
      value: EventStatusFilterTypes.PAST,
      label: window.I18n?.t('customer_directories.filters.event_status_options.past_events') || '',
      checked: values.includes(EventStatusFilterTypes.PAST),
    },
    {
      value: EventStatusFilterTypes.UPCOMING,
      label: window.I18n?.t('customer_directories.filters.event_status_options.upcoming_events') || '',
      checked: values.includes(EventStatusFilterTypes.UPCOMING),
    },
  ];

  if (shouldShowLotteryFilter) {
    OPTIONS.push({
      value: EventStatusFilterTypes.LOTTERY,
      label: window.I18n?.t('customer_directories.filters.event_status_options.lottery_events') || '',
      checked: values.includes(EventStatusFilterTypes.LOTTERY),
    });
  }

  const EVENT_STATUS_OPTIONS_VALUES = [];
  if (!statusFilterVisible.myRegistrations) {
    EVENT_STATUS_OPTIONS_VALUES.push(EventStatusFilterTypes.REGISTERED);
  }
  if (!statusFilterVisible.open) {
    EVENT_STATUS_OPTIONS_VALUES.push(EventStatusFilterTypes.OPEN);
  }

  const eventStatusOptions = {
    statuses: OPTIONS.filter(option => !EVENT_STATUS_OPTIONS_VALUES.includes(option.value)),
    disabled,
  };

  const tooltipText = (
    <div>
      {window.I18n?.t('customer_directories.filters.event_status_tooltip_text.my_registrations') || ''}
      <br />
      {window.I18n?.t('customer_directories.filters.event_status_tooltip_text.registration_open') || ''}
      <br />
      {window.I18n?.t('customer_directories.filters.event_status_tooltip_text.past_events') || ''}
      <br />
      {window.I18n?.t('customer_directories.filters.event_status_tooltip_text.upcoming_events') || ''}
      <br />
      {shouldShowLotteryFilter &&
        (window.I18n?.t('customer_directories.filters.event_status_tooltip_text.lottery_events') || '')}
    </div>
  );

  return (
    <FormGroup>
      <Row>
        <Col xs>
          <div className="add-margin-top-5">
            <h4>
              <span className="label filter-label">
                <div className="add-margin-top-5">
                  <span>
                    {window.I18n?.t('customer_directories.filters.event_status_title') || ''}
                  </span>
                  <span className="pull-right">
                    <GlgTooltipIcon tooltip={tooltipText} placement="bottom">
                      <i className="gga-info-circle" />
                    </GlgTooltipIcon>
                  </span>
                </div>
              </span>
            </h4>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs>
          <GlgCustomDropdown
            dropdownPanel={CheckboxPanel}
            button={
              <DropdownButton options={eventStatusOptions['statuses']} showTours={showTours} />
            }
            offsetY={36}
            optionsForPanel={eventStatusOptions}
            onChange={onChange}
            buttonContainerId="#event_status"
          />
        </Col>
      </Row>
    </FormGroup>
  );
};

EventStatusFilter.propTypes = {
  values: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  statusFilterVisible: PropTypes.object,
  showTours: PropTypes.bool,
  shouldShowLotteryFilter: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default EventStatusFilter;
